// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3YUrr","search":"Settings_search__2QWOZ","filter":"Settings_filter__AOb6g"};